import { Injectable } from '@angular/core';
import * as Config from "../jsons/config.json";


@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  config: any  = Config
  environmentName: any = this.config?.environment;
  breadCrumb : any = this.config?.breadCrumbs
  constructor() { }

  getRatelocApiUrl(): any {
    return this.config?.baseUrls['rateloc'][this.environmentName];
  }
  getQuamtrolApiUrl(): any {
    return this.config?.baseUrls?.quantrol[this.environmentName];
  }
  getAtlasApiUrl(): any {
    return this.config?.baseUrls?.atlas[this.environmentName];
  }

  getBreadcrumb() : any {
    return this.breadCrumb;
  }
}
